import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';

class Reviews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };

    this.toggleShowMore = this.toggleShowMore.bind(this);
  }

  toggleShowMore() {
    const { expanded } = this.state;

    this.setState({ expanded: !expanded });
  }

  renderSeeMore() {
    const { expanded } = this.state;

    return (
      <div className="mt-2">
        <a
          className="body-text-2 expand-projects"
          onClick={this.toggleShowMore}
          role="link"
          tabIndex={0}
        >
          { expanded ? 'See Less' : 'View all testimonials' }
        </a>
      </div>
    );
  }

  render() {
    const { expanded } = this.state;
    const { reviews } = this.props;
    const visibleReviews = expanded ? reviews : reviews.slice(0, 3);

    return (
      <div className="reviews" id="reviews">
        <div className="reviews-overview">
          <div className="g-row--always header">
            <h2>Testimonials</h2>
          </div>
        </div>
        <div>
          { visibleReviews.map((review) => (
            <div className="review" key={review.id}>
              <div className="g-row--always mb-12">
                <h3 className="project-name">{review.project || 'Consultant Review'}</h3>
              </div>
              { review.rating && [
                <StarRatings
                  rating={parseFloat(review.rating)}
                  starRatedColor="#FED500"
                  starHoverColor="#FED500"
                  starEmptyColor="#FFFFFF"
                  starDimension="16px"
                  starSpacing="0px"
                  numberOfStars={1}
                  name="project_rating"
                  key={`${review.id}-star`}
                />,
                <span className="rating" key={`${review.id}-rating`}>
                  {review.rating}
                </span>,
              ]}
              { review.public_comment
                && (
                <p className="comment mb-2">
                  &quot;
                  {review.public_comment}
                  &quot;
                </p>
                )}
              { review.company && <h5>{`- ${review.company}`}</h5> }
            </div>
          ))}
          { reviews.length > 3 ? this.renderSeeMore() : '' }
        </div>
      </div>
    );
  }
}

Reviews.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Reviews;
